export default __webpack_public_path__ + "static/media/lamb_thumb.134a9f05.jpg";